(function(angular){
	'use strict';
	
	angular
		.module('investorDashboard')
		.controller('InvestorDashboard', [
			'APP_BASE_PATH',
			'globalConfig',
			'mixpanelFactory',
			'ReitElementFactory',
			InvestorDashboardCtrl
		]);
	
	function InvestorDashboardCtrl(
		APP_BASE_PATH,
		globalConfig,
		mixpanelFactory,
		ReitElementFactory){
		var dashboard = this;

		dashboard.$onInit = function() {
			angular.extend(dashboard, globalConfig);
			dashboard.basePath = APP_BASE_PATH;
			dashboard.ipoPricePerShareChartView = 'sinceInception';

			ReitElementFactory.getReitElementListsForDashboard()
				.then(function(reitElementLists) {
					angular.extend(dashboard, reitElementLists);
				});
		};
				
		dashboard.trackDocumentLink = function(section, document, dateIssued) {
			mixpanelFactory.track('Investor Dashboard Document Clicked', {
				"Section" : section,
				"Document" : document,
				"Date Issued" : dateIssued
			});
		};
	}
})(window.angular);